<!--首页-->
<template>
  <div>
    <div class="bg-gray">
      <div class="form-content">
        <el-tabs v-model="active" @tab-click="onStatusChange">
          <el-tab-pane
            :label="item.name"
            :name="item.name"
            v-for="item in row.group_list"
          ></el-tab-pane>
        </el-tabs>

        <div class="huiyi-items-wrap">
          <div
            class="huiyi-items-li"
            v-for="(item, i) in groupRow.list"
            :key="i" 
          >
            <div
              class="train-items-top show-two-row items-top1"
              :style="
                'background-image: linear-gradient(to right, #' +
                item.color[0] +
                ' , #' +
                item.color[1] +
                ');'
              "
            >
              <div class="huiyi-type-tip" v-if="item.type_name">
                {{ item.type_name }}
              </div>
              <div class="huiyi-type-tip" v-else>会议</div>
              <div class="train-items-top-city">{{ item.location }}</div>
              <div class="train-items-top-time">{{ item.date_str }}</div>
            </div>
            <div style="flex: 1" class="sai-info-box">
              <p class="sai-title show-two-row">{{ item.name }}</p>
              <div class="sai-info">
                <el-tag type="warning" v-if="item.is_pass">结束</el-tag>
                <el-tag type="success" v-else>进行中</el-tag>
              </div>
            </div>
            <el-row>
              <el-button
                @click="apply(item)"
                type="primary"
                plain
                >进入
              </el-button>
            </el-row>
          </div>
        </div>

        <!--        <div class="more-box" v-show="row.doing.length>0">-->
        <!--          <div class="more-active">-->
        <!--            <div style="display:flex;align-items: center">-->
        <!--              <div class="solid solid2"></div>-->
        <!--              <span class="more-title">正在报名-->
        <!--						</span>-->
        <!--            </div>-->
        <!--            &lt;!&ndash;<div style="display:flex;align-items: center">&ndash;&gt;-->
        <!--            &lt;!&ndash;<div class="more-right">更多</div>&ndash;&gt;-->
        <!--            &lt;!&ndash;<img src="../../../assets/images/arrow.png" alt="" srcset="">&ndash;&gt;-->
        <!--            &lt;!&ndash;</div>&ndash;&gt;-->
        <!--          </div>-->
        <!--          <div style="display:flex;justify-content: space-between; display: none">-->
        <!--            <div class="more-items">-->
        <!--              <img src="../../../assets/images/pic-homepage-Meetings-and-training1.png" alt="" srcset="">-->
        <!--              <span>首次注册</span>-->
        <!--            </div>-->
        <!--            <div class="more-items">-->
        <!--              <img src="../../../assets/images/pic-homepage-Meetings-and-training2.png" alt="" srcset="">-->
        <!--              <span>报名申请</span>-->
        <!--            </div>-->
        <!--            <div class="more-items">-->
        <!--              <img src="../../../assets/images/pic-homepage-Meetings-and-training3.png" alt="" srcset="">-->
        <!--              <span>咨询查询</span>-->
        <!--            </div>-->
        <!--          </div>-->

        <!--          <div class="main-solid"></div>-->
        <!--          <div class="train-box flex-between" style="flex-wrap: wrap;">-->

        <!--            <div class="train-items" v-for="(row,index) in row.doing"-->
        <!--                 v-rblink="{name:'HuiyiApplyFormStep1',query:{huiyiqu_id:row.id}}">-->
        <!--              <div class="train-items-top items-top1"-->
        <!--                   :style="'background-image: linear-gradient(to right, #'+row.color[0]+' , #'+row.color[1]+');'"-->
        <!--              >-->
        <!--                <div>-->
        <!--                  <div class="train-items-top-city">{{ row.location }}</div>-->
        <!--                  <div class="train-items-top-time">{{ row.date_str }}</div>-->
        <!--                </div>-->
        <!--                <div class="train-sing-up-btn">报名</div>-->
        <!--              </div>-->
        <!--              <div class="train-items-title">{{ row.name }}</div>-->
        <!--              <div class="flex-between">-->
        <!--                <div class="train-items-time">{{ row.startdate }}</div>-->
        <!--                <div class="train-items-address">{{ row.province }}·{{ row.city }}</div>-->
        <!--              </div>-->
        <!--            </div>-->

        <!--          </div>-->
        <!--        </div>-->

        <LoginDialog
          :show="loginShow"
          @loginSuccess="loginSuccess"
          @loginCancel="loginCancel"
        />
      </div>
    </div>
  </div>
</template>
<style scoped>
/* @import '../../assets/style/index.css'; */

.row4 {
  /*display: flex;*/
  /*align-items: center;*/
  /*justify-content: space-between;*/
  margin: 10px 10px;
  /*flex-wrap: wrap;*/
}

.row4 img {
  width: 100%;
  float: left;
  width: calc(25% - 10px);
  margin: 0 10px 10px 0;
}

.more-box {
  width: 6.25rem;
  background: #fff;
  margin: 20px auto;
  border-radius: 10px;
  overflow: hidden;
  padding: 20px;
}

.more-active {
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
}

.solid1 {
  background-image: linear-gradient(#1eb2ff, #2b7aff);
}

.solid2 {
  background-image: linear-gradient(#ffc934, #ff9c00);
}

.solid3 {
  background-image: linear-gradient(#ff7d6f, #ff433e);
}

.solid4 {
  background-image: linear-gradient(#e77eff, #8b5afd);
}

.solid5 {
  background-image: linear-gradient(#ffc934, #ff9c00);
}

.solid6 {
  background-image: linear-gradient(#1eb2ff, #2b7aff);
}

.solid7 {
  background-image: linear-gradient(#ff7d6f, #ff4540);
}

.more-items {
  width: 2.02rem;
  position: relative;
  display: flex;
  align-items: center;
}

.more-items img {
  width: 2.02rem;
}

.more-items span {
  font-size: 14px;
  font-family: "PingFangSC-Regular,PingFang SC";
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  position: absolute;
  left: 7px;
}

.more-active .solid {
  width: 4px;
  height: 25px;
  border-radius: 4px;
  margin-right: 5px;
}

.more-active .more-title {
  color: #333;
  font-size: 16px;
  height: 25px;
  line-height: 25px;
}

.more-active .more-right {
  color: #333;
  font-size: 14px;
  height: 25px;
  line-height: 25px;
}

.more-active img {
  margin-left: 5px;
  width: 5.5px;
  height: 10px;
}

.main-solid {
  width: 100%;
  height: 1px;
  background-color: #f8f8f8;
  margin: 10px 0;
}

.flex-between {
  display: flex;
  justify-content: space-between;
}

.fontFamily {
  font-family: "PingFangSC-Regular,PingFang SC";
}

.train-items {
  width: 3.08rem;
  margin-bottom: 0.3rem;
}

.items-top1 {
  background-image: linear-gradient(to right, #01ea9b, #8dec9d);
}

.items-top2 {
  background-image: linear-gradient(to right, #2b7aff, #1eb2ff);
}

.huiyi-type-tip {
  width: 50px;
  color: #fff;
  font-size: 14px;
  background: linear-gradient(
    140deg,
    rgb(253, 157, 0) 0%,
    rgb(250, 100, 0) 100%
  );
  border-radius: 10px 0px 10px 0px;
  /*position: absolute;*/
  /*top: 0;*/
}

.train-items-top {
  width: 160px;
  border-radius: 10px;
  display: flex;
  text-align: center;
  /*align-items: baseline;*/
  flex-direction: column;
  justify-content: center;
  /*padding-left: 0.1rem;*/
  margin-right: 0.1rem;
}

.train-items-top-city {
  font-size: 18px;
  color: #fff;
  overflow: hidden;
}

.train-items-top-time {
  font-size: 16px;
  color: #fff;
  padding-bottom: 0.1rem;
}

.train-sing-up-btn {
  width: 48px;
  height: 26px;
  color: #fff;
  font-size: 12px;
  font-weight: 500;
  font-family: "PingFangSC-Medium,PingFang SC";
  border: 1px solid #fff;
  border-radius: 26px;
  text-align: center;
  line-height: 26px;
}

.train-items-title {
  color: #333;
  font-size: 14px;
  font-weight: 400;
  font-family: "PingFangSC-Medium,PingFang SC";
  margin: 5px 0;
}

.train-items-time,
.train-items-address {
  color: #595757;
  font-size: 12px;
  font-weight: 400;
  font-family: "PingFangSC-Medium,PingFang SC";
}

.train-items-address {
  margin-right: 10px;
}

.box {
  background: #f8f8f8;
  margin-bottom: 50px;
  overflow: hidden;
}

.huiyi-title {
  /*height: 21px;*/
  font-size: 15px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  /* margin-bottom: 10px; */
  color: rgba(0, 0, 0, 1);
  line-height: 24px;
}

.huiyi-info {
  display: flex;
}

.huiyi-info span {
  margin-right: 10px;
}

.huiyi-img {
  width: 1rem;
  height: 1rem;
  display: block;
  margin-right: 10px;
}

.huiyi-data-items {
  width: 7.1rem;
  margin: 0 auto;
  margin-bottom: 20px;
}

.huiyi-items-li {
  display: flex;
  padding: 15px 13px;
  flex-wrap: wrap;
  justify-content: space-around;
}

.huiyi-items-wrap {
  background: rgba(255, 255, 255, 1);
  border-radius: 10px;
  padding: 10px 0;
}
</style>

<script>
import Vue from "vue";
import TabBar from "@/components/TabBar.vue";
import LoginDialog from "@/components/LoginDialog.vue";

export default {
  name: "HuiyiIndex",
  components: {
    TabBar,
    LoginDialog,
  },
  data: function () {
    return {
      loginShow: false,
      showTabBar: false,
      currentIndex: 0,
      active: "全部",
      row: {
        doing: [],
        going: [],
        pass: [],
      },
      catelist: [],
      groupRow: {},
    };
  },
  filter: {},
  watch: {
    active(val) {
      let list = [];
      this.row.group_list.map((group) => {
        if (group.name == val) {
          list = group.list;
        }
      });

      this.groupRow.list = list;
      console.log(
        "🚀 ~ file: HuiyiList.vue ~ line 303 ~ active ~ active",
        list
      );
    },
  },
  mounted() {
    document.title = "会议培训";
    this.showTabBar = window.isApp() ? false : true;
    let that = this;
    that.$api.get(
      "/api/cms/catelist",
      {
        parent_id: 72,
      },
      (res) => {
        that.catelist = res.data;
      },
      (res) => {
        Toast(res.msg);
      }
    );

    this.fetch();
  },
  destroyed() {},
  methods: {
    onStatusChange(item) {
      console.log(
        "🚀 ~ file: HuiyiList.vue ~ line 321 ~ onStatusChange ~ onStatusChange",
        item.name,
        this.huiyiList
      );
      this.active = item.name;
    },
    fetch() {
      let that = this;
      this.$api.get(
        "/api/huiyi/indexData",
        {
          gametype: that.$route.query.gametype,
        },
        (res) => {
          console.log(res);
          that.row = res.data;

          if (res.data.group_list.length > 0) {
            this.groupRow = res.data.group_list[0];
          }
        },
        (res) => {
          console.log("没有登录");
          if (res.code == 401 || res.code == 402) {
            if (window.isApp()) {
              rbLink(
                {
                  name: "login",
                  query: {},
                },
                "replace"
              );
              return false;
            }
            that.loginShow = true;
          } else {
            Toast(res.msg);
          }
        }
      );
    },

    apply(row) {
      if (row.type == "songpei") {
        rbLink({ name: "SongpeiApplyFormBasic", query: { saiqu_id: row.id } });
      } else if (row.type == "cba") {
        rbLink({ name: "CbaApplyFormBasic", query: { station_id: row.id } });
      } else {
        rbLink({ name: "HuiyiApplyFormStep1", query: { saiqu_id: row.id } });
      }
    },

    loginSuccess(res) {
      console.log("-------登录成功--------", res);
      this.loginShow = false;
      this.fetch();
    },

    loginCancel() {
      console.log("-------取消登录--------");
      // this.loginShow = false;
    },
  },
};
</script>



// WEBPACK FOOTER //
// HuiyiList.vue?416f5d9d